'use client';

import { isMembershipRevisionActive } from '@/app/utils';

export const useMembershipRevision = () => {
  return isMembershipRevisionActive();
};
